import React, { memo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useTheme, createUseStyles, Icon, Tooltip } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "../styles/ToggleSidebar";
const useStyles = createUseStyles(styles, 'ToggleSidebar');
const ToggleSidebar = /*#__PURE__*/memo(_ref => {
  let {
    className: classNameProp,
    customColor,
    isExpanded = false,
    isVisible = false,
    onClick = () => {}
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const rootClassName = classnames(classes.root, {
    [classes.isExpanded]: isExpanded,
    [classes.isVisible]: isVisible
  }, classNameProp);
  const getTooltip = () => isExpanded ? t('label_sidebar_contract') : t('label_sidebar_expand');
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement("span", null, getTooltip()),
    placement: "right",
    className: classes.toggleSidebarTooltip
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      background: `linear-gradient(to right, transparent 49%, ${customColor || theme.colors.primary.black} 49.1%)`
    },
    className: rootClassName,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon,
    color: "currentColor",
    name: "chevronRight",
    size: "large"
  })));
});
process.env.NODE_ENV !== "production" ? ToggleSidebar.propTypes = {
  className: PropTypes.string,
  isExpanded: PropTypes.bool,
  isVisible: PropTypes.bool,
  onClick: PropTypes.func
} : void 0;
export default ToggleSidebar;